import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';

export const initialState = {
    invoiceList: [],
    invoicePdfsAvailable: [],
    isLoading: false,
    balance: {}
};

const reducer = createReducer(initialState, {
    [types.FETCH_INVOICE_SUCCESS](state, action) {
        return _.assign({}, state, {
            invoiceList: [...action.response],
            isLoading: false,
        });
    },

    [types.FETCH_INVOICE_REQUEST](state, action) {
        return _.assign({}, state, { 
            isLoading: true,
            invoicePdfsAvailable: [], 
            invoiceList: []
        });
    },

    [types.FETCH_INVOICE_FAILURE](state, action) {
        return _.assign({}, state, {
            invoiceList: [],
            isLoading: false,
        });
    },
    [types.FETCH_BALANCE_SUCCESS](state, action) {
        return _.assign({}, state, {balance: action.response});
    },
    [types.FETCH_BALANCE_REQUEST](state, action) {
        return _.assign({}, state, { balance: {} });
    },

    [types.FETCH_BALANCE_FAILURE](state, action) {
        return _.assign({}, state, { balance: {} });
    },

    // [types.FETCH_INVOICE_AVAILABLE_PDF_REQUEST](state, action) {
    //     return _.assign({}, state, { invoicePdfsAvailable: [] });
    // },
    // [types.FETCH_INVOICE_AVAILABLE_PDF_SUCCESS](state, action) {
    //     return _.assign({}, state, {
    //              invoiceList: state.invoiceList.map(
    //                  invoice => _.assign({}, invoice, {                         
    //                      pdfAvailable: action.response.indexOf(invoice.invoiceNumber) >= 0,                         
    //                     })
    //         ),
    //         invoicePdfsAvailable: action.response
    //     });
    // },
    // [types.FETCH_INVOICE_AVAILABLE_PDF_FAILURE](state, action) {
    //     return _.assign({}, state, { invoicePdfsAvailable: [] });
    // },
});

export default reducer;